import { configurationContainer } from "@/configurationContainer";

export const rentrollPageUrl = (): string =>
    configurationContainer.PUBLIC_RENTROLL_PAGE_URL;
